import request from '@/utils/request'

// 登录
export function login(data) {
  return request.post('/api/admin/login/index', data)
}

// 获取用户信息
export function getInfo(token) {
  return request.get('/api/admin/info', token)
}

// 退出登录
export function logout() {
  return request.get('/api/admin/info/logout')
}

// 获取左侧菜单
export function getMenus(data) {
  return request.get('/api/admin/index/menu', data)
}

// 修改密码
export function setPassword(data) {
  return request.post('/api/admin/info/setPassword', data)
}

// 账号列表
export function listAdmin(data) {
  return request.get('/api/admin/info/listAdmin', data)
}

// 账号新增
export function addAdmin(data) {
  return request.post('/api/admin/info/addAdmin', data)
}

// 账号修改
export function editAdmin(data) {
  return request.post('/api/admin/info/editAdmin', data)
}

// 账号删除
export function deleteAdmin(data) {
  return request.post('/api/admin/info/deleteAdmin', data)
}
// 用户信息

export function info(data) {
  return request.post('/api/admin/info', data)
}

// 用户列表
export function searchMember(data) {
  return request.get('/api/cloudmanagement/admin_user/lists', data);
}




// WEBPACK FOOTER //
// ./src/api/user.js